import React from 'react';
import { withStyles, WithStyles } from '@mui/styles';
import HTTP from 'services/http';
import { buildQaId } from 'utils/build-qa-id';
import { useDispatch } from 'react-redux';
import { Grid, Button } from '@mui/material';
import { notifyError, notifySuccess } from 'actions/action-notifications';
import { FillDeliveryConfirmationStatus } from 'interfaces/enums/TaskStatuses/FillDeliveryConfirmationStatus';
import { IPickUpButton } from './types';
import { ShippingStyles } from './shipping.styles';
import { FDC, EDIT_FILL_DELIVERY_CONFIRMATION } from '../../constants/index';

const qaIdBuilder = buildQaId('shipping');

interface IShippingProps extends IPickUpButton, WithStyles<typeof ShippingStyles> {}

const VoidPickupButton = (props: IShippingProps): JSX.Element | null => {
  const { classes, currentFdcInformation, updateShippingPage = () => {} } = props;
  const [updating, setUpdating] = React.useState(false);
  const dispatch = useDispatch();

  const getVoidPickup = async () => {
    setUpdating(true);
    try {
      const updatedTask = {
        id: currentFdcInformation?.id,
        taskType: FDC,
        therapy_id: currentFdcInformation?.therapyId,
        status_id: FillDeliveryConfirmationStatus.Packed,
      };
      const patchUrl = `/tasks/fdc/${updatedTask.id}`;
      const response = await HTTP.patch(patchUrl, updatedTask, {});
      const reduxPayload = {
        type: EDIT_FILL_DELIVERY_CONFIRMATION,
        payload: response,
      };
      dispatch(reduxPayload);
      dispatch(notifySuccess('FDC was succesfully updated. The pickup was voided.'));
      updateShippingPage();
    } catch (error) {
      const notifyMessage = 'Unable to void/cancel pickup.';
      dispatch(notifyError(notifyMessage));
    } finally {
      setUpdating(false);
    }
  };

  return (
    <Grid item className={classes.voidLabelButton}>
      <Button
        variant="contained"
        color="primary"
        onClick={async () => {
          return getVoidPickup();
        }}
        data-qa-id={qaIdBuilder('button.void-label')}
        disabled={updating}
      >
        {updating ? '....Processing' : 'Void Pickup'}
      </Button>
    </Grid>
  );
};

export default withStyles(ShippingStyles)(VoidPickupButton);
